const breakpointsDown = {
    xs: '575px',
    sm: '767px',
    md: '991px',
    lg: '1199px',
    xl: '1599px'
};
const breakpointsUp = {
    xs: '0px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1600px'
};
export const mediaUtils = {
    down: (key) => `@media (max-width:${breakpointsDown[key]})`,
    up: (key) => `@media (min-width:${breakpointsUp[key]})`
};
